import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { authenticate } from '../../store/actions/login';
import './index.scss';

const ProfileUserDataItem = ({ label, info }) => (
  <div className="data">
    <span className="hat">{label}</span>
    <span className="info">{info}</span>
  </div>
);

ProfileUserDataItem.propTypes = {
  label: PropTypes.string.isRequired
};

class ProfileUserData extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { nomeUsuario, codigo, dddCelular, celular, email } = this.props;
    return (
      <div className="ProfileUserData">
        <div className="content">
          <div className="content--data">
            <div className="description">
              <h5 className="title--data">Seus Dados</h5>
              {codigo && <ProfileUserDataItem label="Código do prestador" info={codigo} />}
              {nomeUsuario && <ProfileUserDataItem label="Nome" info={nomeUsuario} />}
              {celular && (
                <ProfileUserDataItem label="Telefone" info={`(${dddCelular}) ${celular} `} />
              )}
              {email && <ProfileUserDataItem label="Email" info={email} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProfileUserData.propTypes = {
  nomeUsuario: PropTypes.string,
  codigo: PropTypes.number,
  dddCelular: PropTypes.number,
  celular: PropTypes.number,
  email: PropTypes.string,
  complemento: PropTypes.string
};

const mapStateToProps = ({ login }) => ({
  nomeUsuario: login.user.nomeUsuario,
  codigo: login.user.codigo,
  dddCelular: login.user.dddCelular,
  celular: login.user.celular,
  email: login.user.email
});

export default connect(
  mapStateToProps,
  { authenticate }
)(ProfileUserData);
